import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/axiosConfig';
import './CompanySelector.css';

const CompanySelector = ({ onCompanyChange }) => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [showSelector, setShowSelector] = useState(false);
  const [user, setUser] = useState(null);
  const selectorRef = useRef(null);

  useEffect(() => {
    const fetchUserAndCompanies = async () => {
      try {
        // Get current user
        const userRes = await api.get('/auth/profile');
        console.log('CompanySelector - Raw user data from API:', userRes);
        console.log('CompanySelector - User data keys:', Object.keys(userRes.data));
        console.log('CompanySelector - Full user data from API:', JSON.stringify(userRes.data, null, 2));
        setUser(userRes.data);
        
        // Get companies
        const companyRes = await api.get('/companies');
        console.log('CompanySelector - Companies data from API:', companyRes.data);
        setCompanies(companyRes.data);
        
        // Set initial selected company
        let selectedCompanyId = null;
        if (userRes.data.selectedCompany) {
          selectedCompanyId = userRes.data.selectedCompany;
        } else if (userRes.data._doc && userRes.data._doc.selectedCompany) {
          selectedCompanyId = userRes.data._doc.selectedCompany;
        }
        
        console.log('CompanySelector - Initial selected company ID:', selectedCompanyId);
        if (selectedCompanyId) {
          setSelectedCompany(selectedCompanyId);
        }
      } catch (error) {
        console.error('Error fetching user and companies:', error);
      }
    };

    fetchUserAndCompanies();
    
    // Also listen for company change events
    const handleCompanyChange = () => {
      fetchUserAndCompanies();
    };
    
    window.addEventListener('companyChanged', handleCompanyChange);
    
    return () => {
      window.removeEventListener('companyChanged', handleCompanyChange);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setShowSelector(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCompanySelect = async (companyId) => {
    try {
      console.log('CompanySelector - Selecting company:', companyId);
      const res = await api.post('/companies/select', { companyId });
      console.log('CompanySelector - Company selection response:', res.data);
      
      // Update local state
      setSelectedCompany(companyId);
      setShowSelector(false);
      
      // Update user in local storage
      localStorage.setItem('user', JSON.stringify(res.data.user));
      localStorage.setItem('token', res.data.token);
      
      // Notify parent component
      if (onCompanyChange) {
        onCompanyChange(companyId);
      }
      
      // Instead of reloading the page, emit a custom event to refresh data
      window.dispatchEvent(new CustomEvent('companyChanged', { detail: { companyId } }));
    } catch (error) {
      console.error('Error selecting company:', error);
      // Even if there's an error, close the dropdown
      setShowSelector(false);
    }
  };

  // Extract user role and companies from API data + localStorage fallback
  const localUser = JSON.parse(localStorage.getItem('user') || '{}');
  
  let userRole = null;
  let userCompanies = [];
  
  if (user) {
    // Extract role: try all possible structures
    userRole = user.role || (user._doc && user._doc.role) || (user.user && user.user.role) || null;
    // Extract companies: try all possible structures
    userCompanies = user.companies || (user._doc && user._doc.companies) || (user.user && user.user.companies) || [];
  }
  
  // Fallback to localStorage if API data didn't have role
  if (!userRole && localUser.role) {
    userRole = localUser.role;
  }
  if ((!userCompanies || userCompanies.length === 0) && localUser.companies) {
    userCompanies = localUser.companies;
  }
  
  const companyCount = userCompanies ? userCompanies.length : 0;
  
  const shouldShowSelector = user && (
    companyCount > 1 || 
    userRole === 'Administrador' ||
    companies.length > 1
  );
  
  // Always render the component but hide it with CSS if it shouldn't be visible
  const displayStyle = shouldShowSelector ? {} : { display: 'none' };
  
  return (
    <div className="company-selector" ref={selectorRef} style={displayStyle}>
      <button 
        className="company-selector-button"
        onClick={() => setShowSelector(!showSelector)}
        data-tooltip="Trocar entre empresas"
      >
        {console.log('CompanySelector - Selected company ID:', selectedCompany)}
        {console.log('CompanySelector - Companies list:', companies)}
        {selectedCompany 
          ? (() => {
              const selectedCompanyObj = companies.find(c => {
                console.log('CompanySelector - Comparing company IDs:', c._id, selectedCompany, c._id === selectedCompany);
                return c._id === selectedCompany;
              });
              console.log('CompanySelector - Found company object:', selectedCompanyObj);
              return selectedCompanyObj?.name || 'Trocar Empresa';
            })()
          : 'Selecionar Empresa'}
      </button>
      
      {showSelector && (
        <div className="company-selector-dropdown">
          <div className="company-selector-list">
            {companies.map(company => (
              <div
                key={company._id}
                className={`company-selector-item ${
                  selectedCompany === company._id ? 'selected' : ''
                }`}
                onClick={() => handleCompanySelect(company._id)}
              >
                {company.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanySelector;